<template>
  <div class="introduction-box">
    <transition name="introduction-demo">
      <div class="introduction-demo-area" v-show="isaActivated">
        <ul class="body-list">
          <li>
            <div class="introduction-title">翻訳機能</div>
            <p class="introduction-list">日本語⇄中国語翻訳が可能です。</p>
          </li>
          <li>
            <div class="introduction-title">為替計算機能（日本円・人民元）</div>
            <p class="introduction-list">
              日本円及び人民元の為替計算ができます。
            </p>
          </li>
          <li>
            <div class="introduction-title">フリマガ</div>
            <p class="introduction-list">
              中国で東南アジアで発行されている日本語フリーペーバーの
              電子版の閲覧が可能です。
            </p>
          </li>
          <li>
            <div class="introduction-title">引越し・レンタル</div>
            <p class="introduction-list">
              日系大手物流会社のNX NIPPON EXPRESSへの引越しに
              関するお問い合わせが簡単にできます。
              また、浄水器やお掃除キットなどのレンタルに関する
              お問い合わせも可能です。
            </p>
          </li>
        </ul>
      </div>
    </transition>
    <div class="introduction-image">
      <img :src="partsImage" v-show="isaActivated" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      shadow: "box-shadow:0px 0px 108px 0px rgba(238,178,94,0.18);",
      partsImage: null,
      isaActivated: false
    };
  },
  methods: {
    init(partsImage) {
      console.log("partsImage =>", partsImage);
      this.isaActivated = true;
      this.partsImage = partsImage;
      return this.shadow;
    },
    back() {
      this.isaActivated = false;
    }
  }
};
</script>
<style scoped>
.introduction-box {
  width: 100%;
  height: 100%;
  justify-content: space-around;
  display: flex;
  background-color: white;
}
.introduction-image {
  width: 3.5rem;
}
.introduction-demo-area {
  width: 6.8rem;
  padding-top: 1rem;

  height: 100%;

  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.introduction-demo-area ul {
  margin-top: 0.2rem;
}
.introduction-title {
  font-size: 0.4rem;
  font-weight: bold;
  color: #50391e;
}
.introduction-title2 {
  padding-top: 0.2rem;
  font-size: 0.45rem;
  font-weight: bold;
  text-indent: -0.1rem;
  color: #50391e;
}
.introduction-title3 {
  padding-top: 0.2rem;
  font-size: 0.15rem;
  font-weight: bold;
  text-indent: 0.1rem;
  color: #50391e;
}
.introduction-list {
  font-size: 0.2rem;
  font-weight: normal;

  color: #50391e;
  /* width: 100%;
  box-sizing: border-box;
  padding-left: 10px;
  position: relative;
  font-size: 18px;
  line-height: 35px;
  margin-top: 20px;
  font-weight: bold;
  color: #000;
  display: list-item; */
}
.introduction-list1 {
  margin-top: 0.2rem;
  font-size: 0.2rem;
  color: #50391e;
}
/* .introduction-image {
  width: 5rem;
} */
.introduction-image img {
  width: 100%;
  height: auto;
  padding-top: 1rem;
}
.introduction-demo-enter-active,
.introduction-demo-leave-active {
  transition: all 0.5s;
}
.introduction-demo-enter, .introduction-demo-leave-to /* .fade-leave-active below version 2.1.8 */ {
  right: -6.5rem;
}
.food-bottom-icons {
  display: block;
  margin: 0 auto;
  width: 5rem;
}
.body-list li{
	margin-bottom: .2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/home/modules/round-spare-parts/tool.vue